import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { ConsoleShell } from "~/components/shell/console-shell";
import { meQueryOptions } from "~/lib/api/me";
import { requirePartner } from "~/lib/session";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context }) => ({
    partner: await requirePartner(context.queryClient),
  }),
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { data: partner } = useSuspenseQuery(meQueryOptions());

  return (
    <ConsoleShell partner={partner}>
      <Outlet />
    </ConsoleShell>
  );
}
